import { createSignal, onMount } from "solid-js";
import { useApplication } from "@/context/app";
import {
  Card,
  CardContent,
} from "@/components/shadcn/card";
import { activateAction, deactivateAction, deleteAction } from "../../components/ui/actions/config";
import { ListControl } from "../../components/ui/list/ListControl";
import DoctorRow from "./row";
import { ListView } from "../../components/ui/list/ListView";
import { CreateButton } from "../../components/ui/Button";

export default function DoctorList() {

  const { setBreadcrumb } = useApplication();

  const actions = [
    activateAction('doctor', 'doctor'),
    deactivateAction('doctor', 'doctor'),
    deleteAction('doctor', 'doctor')
  ];

  const statuses = [{
    text: 'Active',
    value: true
  }, {
    text: 'Inactive',
    value: false
  }];

  const sorts = [{
    "text": 'Created At',
    "value": "created_at"
  }, {
    "text": 'Name',
    "value": "first_name"
  }];

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: 'Doctors',
        current: true
      }
    ]);
  });

  return (
    <>
      <div class="flex">
        <CreateButton href="/doctor/create">New Doctor</CreateButton>
      </div>
      <Card class="w-full">
        <CardContent>
          <ListControl
            mode="list"
            search={''}
            actions={actions}
            filters={[
              {
                type: 'choice',
                label: 'Status',
                name: 'users.status',
                choices: statuses,
                default: null
              },
              {
                type: 'date',
                label: 'Created At',
                name: 'users.created_at',
                default: null
              }
            ]}
            sort={{
              column: 'users.created_at',
              direction: 'asc',
              options: sorts
            }}
            pagination={{
              current: 1, // default 1
              changePerPage: true, // default true
              perPage: 10, // default 10
              options: [10, 20, 50, 100]
            }}
            datasource={{
              type: 'remote',
              config: {
                url: '/doctor/fetch',
                method: 'GET',
                params: {
                  //status: status()
                }
              }
            }}
            contentLoading={false}
          >{(innerProps) => <ListView {...innerProps} template={DoctorRow} placeholder={false} />}
          </ListControl>
        </CardContent>
      </Card>
    </>
  );
}
